import { storeEvent } from "_analytics/index";

import Presentation from "./presentation";

const component = props => {

	const handleGAEvent = type => {
		storeEvent ( "Profile", type, "Profile" );
	};

	return (
		<Presentation { ...props }
			handleGAEvent = { handleGAEvent }
		/>
	);
};

export default component;